import { Shapes, Info } from 'lucide-react';

import { Badge } from '@/components/ui/badge';
import { PageTitle } from '@/components/page-title';

import { ArtifactsGallery } from '@/components/artifacts/artifacts-gallery';

export function ArtifactsPage() {
  return (
    <div className='flex flex-col gap-6 p-8 2xl:max-w-[1280px] w-full mx-auto'>
      {/* Page header */}
      <div className='flex items-center gap-3'>
        <Shapes className='size-8 text-foreground shrink-0 font-light' />
        <div className='flex flex-wrap items-center gap-3'>
          <PageTitle title='Artifacts' />
          <Badge
            variant='outline'
            className='border-amber-300 bg-amber-50 px-2.5 py-1 text-xs font-medium text-amber-900 dark:border-amber-700 dark:bg-amber-950/40 dark:text-amber-200'
          >
            <Info className='size-3.5' />
            Only artifacts generated after July 2nd, 2026
          </Badge>
        </div>
      </div>

      <ArtifactsGallery syncUrlParams />
    </div>
  );
}
